import{jsx as m}from"react/jsx-runtime";import d,{keyframes as n}from"styled-components";import u from"../../theme.js";import{neutralColorSwap as f}from"../../utils/utils.js";const b=e=>{const r={slow:"2s",default:"1s",fast:"0.5s"};return r[e]||r.default},o=e=>{const r={smaller:1,small:2,regular:3,large:4};return typeof e=="number"?e:r[e]||r.regular},p=n`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`,$=d.div`
  display: inline-block;
  border-radius: 50%;
  border-top: ${({theme:e,color:r,customColor:a,size:t})=>`${o(t)/10}em solid ${a??(r==="neutral"?f(e).mainAlt:e.colors?.[r]?.mainAlt)}`};
  border-bottom: ${({size:e})=>`${o(e)/10}em solid rgba(0, 0, 0, 0.1);`};
  border-right: ${({size:e})=>`${o(e)/10}em solid rgba(0, 0, 0, 0.1);`};
  border-left: ${({size:e})=>`${o(e)/10}em solid rgba(0, 0, 0, 0.1);`};
  width: ${({size:e})=>o(e)}em;
  height: ${({size:e})=>o(e)}em;
  animation: ${p} ${({speed:e})=>b(e)} infinite linear;
  will-change: transform;
`,g=({size:e="regular",color:r="primary",speed:a="default",customColor:t,ariaLabel:i,useAria:l=!0,...s})=>m($,{...l?{role:"status","aria-live":"polite","aria-label":i??"loading","aria-busy":"true"}:void 0,...s,size:e,speed:a,color:r,customColor:t,theme:u});export{g as default};
